module.exports = __webpack_public_path__ + "static/media/smiling.3f15b53b.svg";